var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _c("board", { attrs: { details: _vm.admissionDetailsBoard } }),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("section-title", {
            attrs: {
              "has-line": "",
              title:
                "Historial de Resumen de Resultados de Servicios de Intervención"
            }
          }),
          !_vm.isNewFeaturesImprovementEnabled
            ? _c(
                "div",
                _vm._l(_vm.history, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: `history-item-${index}`,
                      staticClass:
                        "row bg-secondary-3 rounded ml-2 mr-0 p-3 mb-2"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col col-md-1 border-right d-flex align-items-center"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "color-black font-16 font-weight-bold"
                            },
                            [_vm._v(" " + _vm._s(item.statusName) + " ")]
                          )
                        ]
                      ),
                      _c("div", { staticClass: "col col-md-2" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "color-gray-6 font-14 font-weight-normal"
                          },
                          [_vm._v(" Fecha Creación: ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "color-black font-weight-normal" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("date")(item.createdDate)) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "col col-md-2" }, [
                        item.isSubmitted
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "color-gray-6 font-14 font-weight-normal"
                              },
                              [_vm._v(" Fecha Sometido: ")]
                            )
                          : _vm._e(),
                        item.isSubmitted
                          ? _c(
                              "div",
                              { staticClass: "color-black font-weight-normal" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("date")(item.updatedDate)) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-7 mt-3 mt-md-0 d-flex justify-content-end align-items-center"
                        },
                        [
                          item.isSubmitted
                            ? _c("action-button", {
                                staticClass: "outline-success px-2",
                                attrs: {
                                  i: "fas fa-file-search",
                                  text: "Ver Resumen de Resultados",
                                  variant: "outline-success"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.goToResultsSummary(item.id)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            : _c(
                "div",
                [
                  _c(
                    "time-line",
                    { staticClass: "mt-4" },
                    _vm._l(_vm.history, function(item, index) {
                      return _c(
                        "div",
                        { key: `item-index-${index}` },
                        [
                          _c(
                            "time-line-item",
                            {
                              staticClass: "custom-time-line rounded",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "date",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "date-container" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "color-black font-16 font-weight-bold fulldate"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("date")(
                                                        item.statusDate
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "color-black font-12 font-weight-normal hour"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("hour")(
                                                        item.statusDate
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-sm-2 gradient-border text-md-center text-sm-left p-3 order-2 order-md-0 order-sm-2 ml-4 ml-md-0 ml-sm-4 mt-n3 mt-md-0 mt-sm-n3"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-gray-6 font-14 ml-n5 d-sm-none d-md-block font-weight-normal"
                                      },
                                      [_vm._v(" Estatus: ")]
                                    ),
                                    _c("em", {
                                      staticClass: "fa fa-circle font-12 mr-2",
                                      class: `color-${_vm.getColor(
                                        item.summaryStatusId
                                      )}`
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-black font-16 font-weight-bold text-status"
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.summaryStatus) + " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-6 p-3 pl-4 d-flex align-items-center pr-0"
                                  },
                                  [
                                    _c("div", { staticClass: "col" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "color-gray-6 font-14 font-weight-normal label-text"
                                        },
                                        [_vm._v(" Usuario: ")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "color-black font-16 font-weight-bold label-value"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.statusUpdatedBy) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 my-2 border-left d-flex justify-content-center align-items-center toggle-action"
                                  },
                                  [
                                    _c("action-button", {
                                      staticClass: "outline-success px-2",
                                      attrs: {
                                        i: "fas fa-file-search",
                                        text: "Ver Resumen de Resultados",
                                        variant: "outline-success"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.goToResultsSummary(item.id)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }